import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Datepicker from 'react-datepicker';
import * as moment from 'moment';
import 'moment/locale/de';
import config from '../../config/config.js';
import axios from 'axios';
import Select2 from 'react-select2-wrapper';
import swal from 'sweetalert';
import {NotificationManager} from 'react-notifications';
import SSPState from '../elements/SSPState';
import SSPGotFoodStamp from '../elements/SSPGotFoodStamp';
import SSPStewardNumber from '../elements/SSPStewardNumber';
import ChangeShift from '../elements/ChangeShift';
import ChangeShiftVertical from '../elements/ChangeShiftVertical';
import {Link} from 'react-router-dom';
import LoadingOverlay from '../elements/LoadingOverlay';
import ShiftComments from '../elements/shiftDetailsDialog/ShiftComments';
import SupporterGroup from '../elements/SupporterGroup';
import NameHelper from '../../helpers/nameHelper';

class ShiftDetailsDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            editing: false,
            id: null,
            startAt: '',
            endAt: '',
            slots: 0,
            overloadable: false,
            importance: '',
            location: '',
            onlyStewards: false,
            stewardsNeeded: false,
            availableLocations: [],
            shiftSupporterProjects: [],
            availableSupporters: [],
            addingSupporter: false
        };

        this.handleCancelEdit = this.handleCancelEdit.bind(this);
        this.handleStartEdit = this.handleStartEdit.bind(this);
        this.loadShift = this.loadShift.bind(this);
        this.loadAvailableLocations = this.loadAvailableLocations.bind(this);
        this.handleStartAtChange = this.handleStartAtChange.bind(this);
        this.handleEndAtChange = this.handleEndAtChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleIntegerInputChange = this.handleIntegerInputChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleDeleteSupporter = this.handleDeleteSupporter.bind(this);
        this.handleAddSupporter = this.handleAddSupporter.bind(this);
        this.handleSaveAddSupporter = this.handleSaveAddSupporter.bind(this);
        this.handleDeleteShift = this.handleDeleteShift.bind(this);
        this.handleCancelAddSupporter = this.handleCancelAddSupporter.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.componentWillMount = this.componentWillMount.bind(this);
        this.componentWillUnmount = this.componentWillUnmount.bind(this);
    }

    componentWillMount() {
        document.addEventListener('click', this.handleOutsideClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleOutsideClick, false);
    }

    handleClick(e) {
        let node = e.target;
        let found = false;

        // ignore clicks on the component itself
        while (node && node.classList) {
            if (node.classList.contains("modal-content")) {
                found = true;
            }

            node = node.parentNode;
        }
        if (!found) {
            this.props.close();
            return true;
        }
        return false;
    }

    loadShift() {
        this.setState({
            loading: true
        });
        let that = this;
        axios(config.server.endpoint + 'backend/shift/' + this.props.shiftId, {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                if(response.data.success === true) {
                    that.setState({
                        loading: false,
                        id: response.data.id,
                        startAt: moment(response.data.startAt).format('DD.MM.YYYY HH:mm'),
                        endAt: moment(response.data.endAt).format('DD.MM.YYYY HH:mm'),
                        slots: response.data.slots,
                        overloadable: response.data.overloadable,
                        importance: response.data.importance,
                        location: response.data.location,
                        onlyStewards: response.data.onlyStewards,
                        stewardsNeeded: response.data.stewardsNeeded,
                        shiftSupporterProjects: response.data.shiftSupporterProjects,
                        errors: [],
                        addingSupporterErrors: []
                    });
                } else {
                    this.props.close();
                }
            }
        });
    }

    loadAvailableLocations() {
        let that = this;
        axios(config.server.endpoint + 'backend/shift/availableLocations/', {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                that.setState({
                    availableLocations: response.data.data
                })
            }
        });
    }

    handleStartEdit(e) {
        e.preventDefault();
        this.setState({
            editing: true
        });
    }

    handleCancelEdit() {
        this.setState({
            editing: false,
            errors: []
        });
        this.loadShift();
    }

    componentDidMount() {
        this.loadAvailableLocations();
        this.loadShift();
    }

    handleStartAtChange(date) {
        this.setState({
            startAt: moment(date).format('DD.MM.YYYY HH:mm'),
            endAt: moment(date).add(6, 'hour').format('DD.MM.YYYY HH:mm')
        });
    }

    handleEndAtChange(date) {
        this.setState({
            endAt: moment(date).format('DD.MM.YYYY HH:mm')
        });
    }

    handleInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleIntegerInputChange(e) {
        this.setState({
            [e.target.name]: parseInt(e.target.value)
        });
    }

    handleCheckboxChange(e) {
        this.setState({
            [e.target.name]: !this.state[e.target.name]
        });
    }

    handleFormSubmit(e) {
        e.preventDefault();
        this.setState({
            loading: true
        });
        axios(config.server.endpoint + 'backend/shift/' + this.state.id, {
            method: 'put',
            data: {
                startAt: this.state.startAt,
                endAt: this.state.endAt,
                slots: this.state.slots,
                overloadable: this.state.overloadable,
                importance: this.state.importance,
                location: this.state.location
            }
        }).then((response) => {
            if (response.status === 200) {
                if (response.data.success === true) {
                    this.loadShift();
                    this.props.reloadSchedule();
                    this.setState({
                        editing: false,
                        errors: []
                    });
                } else {
                    this.setState({
                        loading: false,
                        errors: response.data.errors
                    })
                }
            }
        });
    }

    handleDeleteShift(e) {
        e.preventDefault();
        const { t } = this.props;
        swal({
            title: t('shiftDetails.shift.delete.really.title'),
            text: t('shiftDetails.shift.delete.really.text'),
            icon: 'warning',
            buttons: true,
            dangerMode: true
        }).then((reallyDo) => {
            if (reallyDo) {
                axios(config.server.endpoint + 'backend/shift/' + this.state.id, {
                    method: 'delete'
                }).then((response) => {
                    if(response.status === 200 && response.data.success === true) {
                        NotificationManager.success(t('shiftDetails.shift.delete.success'), t('default.notification.action.success'), 5000);
                        this.props.reloadSchedule();
                        this.props.close();
                    }
                })
            }
        })
    }

    handleDeleteSupporter(supporterId) {
        const {t} = this.props;

        swal({
            title: t('shiftDetails.supporter.delete.really.title'),
            text: t('shiftDetails.supporter.delete.really.text'),
            icon: 'warning',
            buttons: true,
            dangerMode: true
        }).then((reallyDo) => {
            if (reallyDo) {
                axios(config.server.endpoint + 'backend/shift/supporter/' + this.state.id + '/' + supporterId, {
                    method: 'delete'
                }).then((response) => {
                    this.loadShift();
                })
            }
        })
    }

    handleAddSupporter() {
        this.setState({
            loading: true
        });
        let that = this;
        axios(config.server.endpoint + 'backend/shift/availableSupporterProjectsForShift/' + this.state.id, {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                that.setState({
                    availableSupporters: response.data,
                    addingSupporter: true,
                    supporterToAdd: null,
                    loading: false
                })
            }
        });
    }

    handleCancelAddSupporter() {
        this.setState({
            supporterToAdd: null,
            addingSupporter: false
        });
    }

    handleSaveAddSupporter(e) {
        e.preventDefault();
        this.setState({
            loading: true
        });
        axios(config.server.endpoint + 'backend/shift/supporter/' + this.state.id + '/' + this.state.supporterToAdd, {
            method: 'post'
        }).then((response) => {
            if (response.status === 200) {
                if (response.data.success === true) {
                    this.loadShift();
                    this.props.reloadSchedule();
                    this.setState({
                        addingSupporter: false,
                        addingSupporterErrors: []
                    });
                } else {
                    this.setState({
                        loading: false,
                        addingSupporterErrors: response.data.errors
                    })
                }
            }
        });
    }

    render() {
        const { t } = this.props;
        return (
            <div className="ShiftDetailsDialog modal inmodal in" tabIndex="-1" role="dialog" style={{display: 'block'}} ref={node => { this.node = node; }} onClick={this.handleClick}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button className="close" onClick={this.props.close}>
                                <span>x</span>
                            </button>
                            <h4 className="modal-title">
                                {t('shiftDetailsDialog.title')}
                            </h4>
                        </div>
                        <div className={this.state.loading ? 'LoadingOverlayContainer' : ''}>
                            {this.state.loading ? (
                                <LoadingOverlay/>
                            ) : null}
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-lg-7">
                                        <form onSubmit={this.handleFormSubmit}>
                                            <div className="row">
                                                <div className="col-xs-6">
                                                    <div
                                                        className={"form-group" + ((this.state.errors && this.state.errors.startAt) ? ' has-error' : '')}>
                                                        <label>{t('shiftDetails.startAt.label')}</label>
                                                        {this.state.editing ? (
                                                            <Datepicker
                                                                selected={this.state.startAt ? moment(this.state.startAt, 'DD.MM.YYYY HH:mm') : null }
                                                                dateFormat="DD.MM.YYYY HH:mm" locale={moment.locale('de')}
                                                                timeFormat="HH:mm"
                                                                className="form-control"
                                                                value={this.state.startAt}
                                                                showTimeSelect
                                                                readOnly={!this.state.editing}
                                                                timeCaption="time"
                                                                onChange={this.handleStartAtChange}/>
                                                        ) : (
                                                            <input type="text" readOnly={true} value={this.state.startAt} className="form-control"/>
                                                        )}


                                                        {(this.state.errors && this.state.errors.startAt) ? (
                                                            <span className="help-block">
                                                                {t('shiftDetails.startAt.error.' + this.state.errors.startAt)}
                                                            </span>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-xs-6">
                                                    <div
                                                        className={"form-group" + ((this.state.errors && this.state.errors.endAt) ? ' has-error' : '')}>
                                                        <label>{t('shiftDetails.endAt.label')}</label>
                                                        {this.state.editing ? (
                                                            <Datepicker
                                                                selected={this.state.endAt ? moment(this.state.endAt, 'DD.MM.YYYY HH:mm') : null }
                                                                dateFormat="DD.MM.YYYY HH:mm" locale={moment.locale('de')}
                                                                timeFormat="HH:mm"
                                                                className="form-control"
                                                                value={this.state.endAt}
                                                                showTimeSelect
                                                                timeCaption="time"
                                                                onChange={this.handleEndAtChange}/>
                                                        ) : (
                                                            <input type="text" readOnly={true} value={this.state.endAt} className="form-control"/>
                                                        )}

                                                        {(this.state.errors && this.state.errors.endAt) ? (
                                                            <span className="help-block">
                                                                {t('shiftDetails.endAt.error.' + this.state.errors.endAt)}
                                                            </span>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xs-3">
                                                    <div
                                                        className={"form-group" + ((this.state.errors && this.state.errors.slots) ? ' has-error' : '')}>
                                                        <label>{t('shiftDetails.slots.label')}</label>
                                                        <input type="number" className="form-control" name="slots" value={this.state.slots} onChange={this.handleInputChange} readOnly={!this.state.editing}/>

                                                        {(this.state.errors && this.state.errors.slots) ? (
                                                            <span className="help-block">
                                                                {t('shiftDetails.slots.error.' + this.state.errors.slots)}
                                                            </span>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-xs-3">
                                                    <div
                                                        className={"form-group" + ((this.state.errors && this.state.errors.overloadable) ? ' has-error' : '')}>
                                                        <label>{t('shiftDetails.overloadable.label')}</label>
                                                        <input type="checkbox" className="form-control" name="overloadable" checked={this.state.overloadable} onChange={this.handleCheckboxChange} disabled={!this.state.editing}/>

                                                        {(this.state.errors && this.state.errors.overloadable) ? (
                                                            <span className="help-block">
                                                                {t('shiftDetails.overloadable.error.' + this.state.errors.overloadable)}
                                                            </span>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-xs-6">
                                                    <div
                                                        className={"form-group" + ((this.state.errors && this.state.errors.importance) ? ' has-error' : '')}>
                                                        <label>{t('shiftDetails.importance.label')}</label>
                                                        <select name="importance" className="form-control" value={this.state.importance} onChange={this.handleInputChange} disabled={!this.state.editing}>
                                                            {['LOW', 'MEDIUM_LOW', 'MIDDLE', 'MEDIUM_HIGH', 'HIGH'].map((importance, i) => (
                                                                <option value={importance} key={i}>
                                                                    {t('shiftDetails.importance.' + importance)}
                                                                </option>
                                                            ))}
                                                        </select>

                                                        {(this.state.errors && this.state.errors.importance) ? (
                                                            <span className="help-block">
                                                                {t('shiftDetails.importance.error.' + this.state.errors.importance)}
                                                            </span>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xs-12">
                                                    <div
                                                        className={"form-group" + ((this.state.errors && this.state.errors.location) ? ' has-error' : '')}>
                                                        <label>{t('shiftDetails.location.label')}</label>
                                                        {this.state.editing ? (
                                                            <Select2 data={this.state.availableLocations.map((el) => {
                                                                return {
                                                                    text: (el.name + (el.name !== el.locationGroupName ? ' (' + el.locationGroupName + ')' : '')), id: el.id
                                                                }
                                                            })} value={this.state.location} onChange={this.handleIntegerInputChange} name="location"
                                                                     readOnly={!this.state.editing}
                                                                     options={{placeholder: t('shiftDetails.location.placeholder')}}
                                                                     className="width-100p block"/>
                                                        ) : (
                                                            <input type="text" readOnly={true} value={(this.state.location && this.state.availableLocations.length > 0) ? this.state.availableLocations.find((el) => {return el.id === this.state.location}).name : ''} className="form-control"/>
                                                        )}

                                                        {(this.state.errors && this.state.errors.location) ? (
                                                            <span className="help-block">
                                                                {t('shiftDetails.location.error.' + this.state.errors.location)}
                                                            </span>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            {this.props.roles.find((role) => role === 'ROLE_SHIFT_ADMIN') ? (
                                              <div className="row">
                                                  <div className="col-xs-12 text-right">
                                                      {this.state.editing ? (
                                                        <button className="btn btn-default m-r"
                                                                disabled={this.state.loading}
                                                                onClick={this.handleCancelEdit}>
                                                            {t('default.cancel')}
                                                        </button>
                                                      ) : (
                                                        <button className="btn btn-danger m-r"
                                                                disabled={this.state.loading}
                                                                onClick={this.handleDeleteShift}>
                                                            {t('default.delete')}
                                                        </button>
                                                      )}
                                                      {this.state.editing ? (
                                                        <button className="btn btn-primary" type="submit"
                                                                disabled={this.state.loading}>
                                                            {t('default.save')}
                                                        </button>
                                                      ) : (
                                                        <button className="btn btn-primary" type="button"
                                                                disabled={this.state.loading}
                                                                onClick={this.handleStartEdit}>
                                                            {t('default.edit')}
                                                        </button>
                                                      )}
                                                  </div>
                                              </div>
                                            ) : null}
                                        </form>
                                        <div className="row">
                                            <div className="col-xs-12">
                                                {this.state.id ? (
                                                    <ShiftComments shiftId={this.state.id} reloadSchedule={this.props.reloadSchedule}/>
                                                ) : null }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-5">
                                        <div>
                                            <div className="pull-right btn-group btn-group-xs">
                                                <button type="button" onClick={this.handleAddSupporter}
                                                        className="btn btn-primary">
                                                    <i className="fa fa-plus"/>
                                                </button>
                                            </div>
                                            <label>
                                                {t('shiftDetails.supporters')} ({this.state.shiftSupporterProjects.length})
                                            </label>
                                        </div>
                                        {this.state.addingSupporter ? (
                                            <form onSubmit={this.handleSaveAddSupporter} className="m-b">
                                                <div className="row">
                                                    <div className="col-xs-12">
                                                        <div
                                                            className={"form-group" + ((this.state.addingSupporterErrors && this.state.addingSupporterErrors.supporter) ? ' has-error' : '')}>
                                                            <label>{t('shiftDetails.supporterToAdd.label')}</label>
                                                            <Select2 data={this.state.availableSupporters.map((el) => {
                                                                return {
                                                                    text: (NameHelper.displayName(el.supporter) + ' (' + el.shiftsAssigned + '/' + el.shiftsNeeded + ')'), id: el.supporter.id
                                                                }
                                                            })} value={this.state.supporterToAdd} onChange={this.handleInputChange} name="supporterToAdd"
                                                                     disabled={this.state.loading}
                                                                     options={{placeholder: t('shiftDetails.supporterToAdd.placeholder')}}
                                                                     className="width-100p block"/>

                                                            {(this.state.addingSupporterErrors && this.state.addingSupporterErrors.supporter) ? (
                                                                <span className="help-block">
                                                        {t('shiftDetails.supporterToAdd.error.' + this.state.addingSupporterErrors.supporter)}
                                                    </span>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 text-right">
                                                        <button type="button" onClick={this.handleCancelAddSupporter} className="btn btn-default" disabled={this.state.addingLoading}>
                                                            {t('default.cancel')}
                                                        </button>
                                                        <button type="submit" className="btn btn-primary" disabled={this.state.addingLoading}>
                                                            {t('default.save')}
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        ) : null }
                                        <table className="table m-t">
                                            <tbody>
                                            {this.state.shiftSupporterProjects.map((ssp) => (
                                                <tr>
                                                    <td style={ssp.isSteward ? {background: '#ffbb73'} : ssp.availableForBottleDeposit ? {background: '#c6caff'} : {}}>
                                                        <div>
                                                            <div className="pull-right btn-group btn-group-xs">
                                                                <button type="button" onClick={() => this.handleDeleteSupporter(ssp.supporter.id)}
                                                                        className="btn btn-danger">
                                                                    <i className="fa fa-trash"/>
                                                                </button>
                                                            </div>
                                                            <div className="pull-right btn-group btn-group-xs">
                                                                {ssp.state.name === 'ASSIGNED' ? (
                                                                    <SSPState style="primary" icon="check" id={ssp.id} newState="CONFIRMED" handleSaveSuccess={this.loadShift}/>
                                                                ) : null}
                                                                {ssp.state.name === 'CONFIRMED' ? (
                                                                    <SSPState style="primary" icon="arrow-right" id={ssp.id} newState="CHECKED_IN" handleSaveSuccess={this.loadShift}/>
                                                                ) : null}
                                                                {ssp.state.name === 'CHECKED_IN' ? (
                                                                    <SSPState style="primary" icon="check" id={ssp.id} newState="CHECKED_OUT" handleSaveSuccess={this.loadShift}/>
                                                                ) : null}
                                                                {ssp.state.name === 'CHECKED_IN' ? (
                                                                    <SSPState style="warning" icon="times" id={ssp.id} newState="CANCELLED" handleSaveSuccess={this.loadShift}/>
                                                                ) : null}
                                                            </div>
                                                            <div className="pull-right btn-group btn-group-xs">
                                                                <SSPGotFoodStamp id={ssp.id} handleSaveSuccess={this.loadShift} checked={ssp.gotFoodStamp}/>
                                                            </div>
                                                            {(this.state.onlyStewards || this.state.stewardsNeeded) ? (
                                                                <div className="pull-right btn-group btn-group-xs">
                                                                    <SSPStewardNumber id={ssp.id} handleSaveSuccess={() => { this.loadShift(); this.props.reloadSchedule(); }} stewardNumber={ssp.stewardNumber}/>
                                                                </div>
                                                            ) : null}
                                                            {['ASSIGNED', 'CONFIRMED'].includes(ssp.state.name) ? (
                                                                <div className="pull-right btn-group btn-group-xs">
                                                                    <ChangeShiftVertical id={ssp.id} handleClose={this.loadShift}/>
                                                                    <ChangeShift id={ssp.id} handleClose={this.loadShift}/>
                                                                </div>
                                                            ) : null}
                                                            <Link to={"/supporter/" + ssp.supporter.id} onClick={this.props.close} className={!ssp.supporterProject.onSite ? "text-muted" : null}><b>{NameHelper.displayName(ssp.supporter) || (t('supporterDetails.firstname.notSet') + ' ' + t('supporterDetails.lastname.notSet'))}</b></Link>
                                                            {ssp.supporterGroup && ssp.supporterGroup.name !== null ? (
                                                                <span>
                                                                    &nbsp;(<SupporterGroup id={ssp.supporterGroup.id} name={ssp.supporterGroup.name} onSupporterClick={this.props.close}/>)
                                                                </span>
                                                            ): ''}
                                                            {ssp.isSteward ? (
                                                                <small className="m-l-md">
                                                                    <i className="fa fa-shield m-r-xs" title={t('overview.project.period.supporterStewardFormReceivedAmount')}/>
                                                                </small>
                                                            ) : null}
                                                        </div>
                                                        <div>
                                                            {ssp.state.name}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default translate()(ShiftDetailsDialog);
